import {
  create_order_record,
  direct_delete_order_record,
  query_order_record_normal_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model2/mjstore/mjstore-orderrecord-config';

import { reactive } from 'vue';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'order_code',
      label: '下单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写下单号',
    },
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目名称',
      disabled: false,
      placeholder: '请选择项目名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remotemodal',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'remotemodal',
      name: 'card_id',
      label: '卡',
      disabled: false,
      placeholder: '请选择卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-card',
    },

    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: '促销政策',
      disabled: false,
      placeholder: '请选择促销政策',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '下单时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      showTime: true,
      placeholder: '请选择下单时间',
    },
    {
      type: 'remotemodal',
      name: 'delete_staff_id',
      label: '撤单执行人',
      disabled: false,
      placeholder: '请选择撤单执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    project_id: null,
    customer_id: null,
    staff_id: null,
    card_id: null,
    card_record_id: null,
    cxzc_id: null,
    shop_id: null,
    date: null,
    is_delete: false,
    delete_staff_id: null,
  }),
};
const search_options = {
  is_delete: [
    { value: None, name: '全部' },
    { value: True, name: '已撤单' },
    { value: False, name: '未撤单' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目名称',
      disabled: false,
      placeholder: '请选择项目名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    {
      type: 'input',
      name: 'total_num',
      label: '项目次数',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写购买单数',
    },
    {
      type: 'input',
      name: 'order_code',
      label: '下单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写下单号',
    },
    {
      type: 'input',
      name: 'price',
      label: '总价',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写总价',
    },
    {
      type: 'input',
      name: 'czje',
      label: '充值使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写充值使用金额',
    },
    {
      type: 'input',
      name: 'flje',
      label: '返利使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写返利使用金额',
    },
    {
      type: 'input',
      name: 'zjfl',
      label: '直接返利',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写直接返利',
    },
    {
      type: 'input',
      name: 'zjje',
      label: '赠券使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写赠券使用金额',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '下单日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      showTime: true,
      placeholder: '请选择下单日期',
    },
    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: '促销政策',
      disabled: false,
      placeholder: '请选择促销政策',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {
    customer_id: [{ required: true, message: '请填输入会员姓名' }],
    date: [{ required: true, message: '请选择下单日期' }],
    shop_id: [{ required: true, message: '请填输入执行门店' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    project_id: null,
    customer_id: null,
    total_num: null,
    price: null,
    czje: null,
    flje: null,
    zjfl: null,
    zjje: null,
    date: null,
    cxzc_id: null,
    shop_id: null,
    staff_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '下单记录管理',
  addModalTitle: '新建下单记录',
  updateTitle: '修改下单记录',
  del_btn: '作废',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '下单日期',
    width: 135,
    dataIndex: 'date',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '项目类别',
    width: 100,
    dataIndex: 'project__project_type__name',
    checked: true,
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '生美项目', value: '生美项目' },
      { text: '医美项目', value: '医美项目' },
      { text: '养发项目', value: '养发项目' },
      { text: '康养项目', value: '康养项目' },
    ],
  },
  {
    title: '项目名称',
    width: 180,
    dataIndex: 'project__name',
    checked: true,
  },
  {
    title: '项目余次',
    width: 80,
    dataIndex: 'now_num',
    checked: true,
  },
  {
    title: '耗单次数',
    width: 80,
    dataIndex: 'used_num',
    checked: true,
  },
  {
    title: '撤单次数',
    width: 80,
    dataIndex: 'cancel_num',
    checked: true,
  },

  {
    title: '项目次数',
    width: 80,
    dataIndex: 'total_num',
    checked: true,
  },
  {
    title: '项目单价',
    width: 80,
    dataIndex: 'project_price',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '项目金额',
    width: 80,
    dataIndex: 'price',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '充值使用金额',
    width: 110,
    dataIndex: 'czje',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '返利使用金额',
    width: 110,
    dataIndex: 'flje',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '直接返利',
    width: 110,
    dataIndex: 'zjfl',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '赠券使用金额',
    width: 110,
    dataIndex: 'zjje',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '促销政策',
    width: 150,
    dataIndex: 'cxzc__name',
    checked: true,
  },

  {
    title: '备注',
    width: 200,
    dataIndex: 'mark',
    checked: true,
  },
  {
    title: '订单号',
    width: 190,
    dataIndex: 'order_code',
    checked: true,
  },
  {
    title: '诉求号',
    width: 170,
    dataIndex: 'require_info__code',
    checked: true,
  },
  {
    title: '所属顾问',
    width: 150,
    dataIndex: 'customer__adviser__name',
    checked: true,
  },
  {
    title: '执行门店',
    width: 80,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '执行人',
    width: 80,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '执行情况',
    width: 150,
    dataIndex: 'is_now_num',
    checked: true,
    slots: { customRender: 'is_now_num' },
    filterMultiple: false,
    filters: [
      { text: '待执行', value: true },
      { text: '执行完', value: false },
    ],
  },
  {
    title: '单据状态',
    width: 150,
    dataIndex: 'is_delete',
    checked: true,
    slots: { customRender: 'is_delete' },
    filterMultiple: false,
    filters: [
      { text: '未作废', value: false },
      { text: '已作废', value: true },
    ],
  },
  {
    title: '确认日期',
    width: 135,
    dataIndex: 'receipt_datetime',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '操作',
    width: 240,
    dataIndex: 'action',
    checked: true,
    slots: { customRender: 'action' },
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push(
  {
    type: 'custom',
    slotName: 'is_now_num',
    field_true: '待执行',
    field_false: '执行完',
  },
  { type: 'custom', slotName: 'is_delete', field_true: '已作废', field_false: '未作废' },
);
export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_order_record_normal_list,
    addData: create_order_record,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
